import styled from 'styled-components';

export const BoxLabel = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TextScreen = styled.span`
  color: #7e7e7e;
  font-weight: bold;
  font-size: 0.8125rem;
  text-align: left;
`;

export const ContainerModalPreview = styled.div`
  background-color: ${({ theme }) => theme.white};
  min-width: 700px;
  padding: 15px;

  @media (max-width: 900px) {
    min-width: 85%;
    min-height: 85%;
    max-width: 85%;
    max-height: 85%;
    margin: auto;
    overflow: auto;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  background: ${({ theme }) => theme.pantone656C};
  padding: 1rem;
  border-radius: 8px;
  width: 100%;
`;